import React, { useState } from "react";
import swal from "sweetalert";
import { Helmet } from "react-helmet";
import "./Contact.css";

const Contact = () => {
  // State to store form values and error messages
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const [errors, setErrors] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Form validation function
  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    // Name validation
    if (!formData.name) {
      formErrors.name = "Name is required.";
      isValid = false;
    }

    // Phone validation (assuming phone number is required and should have digits only)
    if (!formData.phone) {
      formErrors.phone = "Phone number is required.";
      isValid = false;
    } else if (!/^\d+$/.test(formData.phone)) {
      formErrors.phone = "Phone number must contain only digits.";
      isValid = false;
    }

    // Email validation
    if (!formData.email) {
      formErrors.email = "Email is required.";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      formErrors.email = "Email is not valid.";
      isValid = false;
    }

    // Message validation
    if (!formData.message) {
      formErrors.message = "Message is required.";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      swal("Success!", "Form is submitted successfully!", "success");
      // You can add actual form submission logic here (e.g., send the data to an API)
    } else {
      swal("Oops!", "Something went wrong!", "error");
    }
  };

  return (
    <>
      <Helmet>
        <title>Contact Us | Get in Touch with [interior]</title>
        <meta
          name="description"
          content="Have questions or need interior design services? Contact [Your Company Name] to get in touch with our expert team for personalized design solutions."
        />
        <meta
          name="keywords"
          content="contact, interior design contact, home design inquiries, office design services, interior design consultation"
        />
      </Helmet>
      <div className="container">
        <div className="row">
          <div className="col-12 col-xl-3"></div>
          <div className="col-12 col-xl-6">
            <h2 className="text-center mt-4">Contact Us</h2>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  id="custom-input"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Enter your name"
                />
                {errors.name && (
                  <small className="text-danger">{errors.name}</small>
                )}
              </div>

              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  id="custom-input"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  placeholder="Enter your Number"
                />
                {errors.phone && (
                  <small className="text-danger">{errors.phone}</small>
                )}
              </div>

              <div className="mb-3">
                <input
                  type="email"
                  className="form-control"
                  id="custom-input"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Enter your email"
                />
                {errors.email && (
                  <small className="text-danger">{errors.email}</small>
                )}
              </div>

              <div className="mb-3">
                <textarea
                  className="form-control"
                  id="custom-input"
                  name="message"
                  rows="4"
                  value={formData.message}
                  onChange={handleInputChange}
                  placeholder="Your message"
                ></textarea>
                {errors.message && (
                  <small className="text-danger">{errors.message}</small>
                )}
              </div>

              <div className="text-center mt-2">
                <button type="submit" className="mybutton mb-5">
                  Submit
                </button>
              </div>
            </form>
          </div>
          <div className="col-12 col-xl-3"></div>
        </div>
      </div>
      <div className="container">
      <div className="row">
        <div style={{ width: '100%' }}>
          <iframe
            width="100%"
            height="300"
            frameBorder="0"
            scrolling="no"
            marginHeight="0"
            marginWidth="0"
            src="https://maps.google.com/maps?width=100%25&height=600&hl=en&q=Bangalore+(Interior%20xyz)&t=&z=14&ie=UTF8&iwloc=B&output=embed"
            title="Google Map"
          >
            <a href="https://www.gps.ie/">gps systems</a>
          </iframe>
        </div>
      </div>
    </div>
    </>
  );
};

export default Contact;
